import { IconCheck, IconX, IconCancel, IconProgressCheck, IconSignatureOff } from "@tabler/icons-react";

export enum EnumEstadoTarea {
    Creada = 1,
    EnCurso = 2,
    Exitoso = 3,
    Fallido = 4,
    PendienteFirma = 5,
    Cancelado = 6,
}

export const EstadoTareaColors = {
    [EnumEstadoTarea.Exitoso]: "#5fd373",
    [EnumEstadoTarea.Fallido]: "#f58585",
    [EnumEstadoTarea.PendienteFirma]: "#e9d255",
    [EnumEstadoTarea.Creada]: "#0074d9",
    [EnumEstadoTarea.EnCurso]: "#9b59b6", 
    [EnumEstadoTarea.Cancelado]: "#95a5a6",
};


export const EstadoTareaIconos = {
    [EnumEstadoTarea.Exitoso]: IconCheck,
    [EnumEstadoTarea.Fallido]: IconX,
    [EnumEstadoTarea.PendienteFirma]: IconSignatureOff,
    [EnumEstadoTarea.Creada]: IconCheck,
    [EnumEstadoTarea.EnCurso]: IconProgressCheck,
    [EnumEstadoTarea.Cancelado]: IconCancel,
  };
  